import React from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import Banner from "../../Assets/Contact/ContactBanner.png";
import ContactDetails from '../../components/User/ContactUs/ContactDetails';
const ContactUs = () => {
  return (
    <div className='overflow-hidden'>
      <CommonBanner backgroundImage={Banner} title="Contact Us" subheading="Home/Contact Us" />
      <ContactDetails />
    </div>
  )
}

export default ContactUs